import type { IconNode } from '../types';

/**
 * @name ice-skate
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTEgMnY5IiAvPgogIDxwYXRoIGQ9Ik0xMSA3IDggOCIgLz4KICA8cGF0aCBkPSJNMTEgMyA0IDV2MTFhMiAyIDAgMCAwIDIgMmgxMGEyIDIgMCAwIDAgMi0yIDMuMDggMy4wOCAwIDAgMC0xLjgtMi44TDExIDExbC0zIDEiIC8+CiAgPHBhdGggZD0iTTcgMTh2NCIgLz4KICA8cGF0aCBkPSJNMTUgMTh2NCIgLz4KICA8cGF0aCBkPSJNNCAyMmgxMmMyLjEgMCAzLjktMS4xIDUtMi43IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/ice-skate
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const iceSkate: IconNode = [
  ['path', { d: 'M11 2v9', key: '44sqy' }],
  ['path', { d: 'M11 7 8 8', key: 'zbks1s' }],
  [
    'path',
    {
      d: 'M11 3 4 5v11a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2 3.08 3.08 0 0 0-1.8-2.8L11 11l-3 1',
      key: 'nc3tzf',
    },
  ],
  ['path', { d: 'M7 18v4', key: '1py7xm' }],
  ['path', { d: 'M15 18v4', key: '1obqtg' }],
  ['path', { d: 'M4 22h12c2.1 0 3.9-1.1 5-2.7', key: '1la23u' }],
];

export default iceSkate;
